// "Read aloud" setting: whether new translations are spoken automatically.
// Stored under the existing 'polyglot-autoplay' key so it carries over.

import { icons } from './icons.js';

const KEY = 'polyglot-autoplay';
const EVENT = 'pg:readaloud';

export function isReadAloudOn() {
    const saved = localStorage.getItem(KEY);
    return saved === null ? true : saved === 'true';
}

export function setReadAloud(on) {
    localStorage.setItem(KEY, String(on));
    const tts = window.ttsAudioService;
    if (tts) {
        tts.setAutoPlay(on);
        if (!on) {
            // Turning it off should silence what's queued or playing right now.
            tts.clearQueue?.();
            if (tts.currentAudio && !tts.currentAudio.paused) {
                tts.currentAudio.pause();
            }
        }
    }
    window.dispatchEvent(new CustomEvent(EVENT, { detail: { on } }));
}

export function onReadAloudChange(callback) {
    const handler = (e) => callback(e.detail.on);
    window.addEventListener(EVENT, handler);
    return () => window.removeEventListener(EVENT, handler);
}

/**
 * The header control. `variant: 'pill'` shows a labelled switch (Translate app);
 * `variant: 'icon'` is a compact toggle button (Room app header).
 */
export function createReadAloudControl({ variant = 'pill' } = {}) {
    const btn = document.createElement('button');
    btn.type = 'button';

    const render = (on) => {
        if (variant === 'icon') {
            btn.className = 'pg-iconbtn';
            btn.setAttribute('aria-pressed', String(on));
            btn.setAttribute('aria-label', 'Read translations aloud');
            btn.title = on ? 'Read aloud is on' : 'Read aloud is off';
            btn.innerHTML = on ? icons.speaker : icons.speakerOff;
        } else {
            btn.className = 'pg-switch';
            btn.setAttribute('role', 'switch');
            btn.setAttribute('aria-checked', String(on));
            btn.innerHTML = `${on ? icons.speaker : icons.speakerOff}<span class="pg-switch__label">Read aloud</span><span class="pg-switch__track" aria-hidden="true"></span>`;
            btn.setAttribute('aria-label', 'Read translations aloud');
        }
    };

    render(isReadAloudOn());
    btn.addEventListener('click', () => setReadAloud(!isReadAloudOn()));
    onReadAloudChange(render);
    return btn;
}
